import React, { useState } from "react";
import PropTypes from "prop-types";

// The deck is generated from Wiktionary, which is good but not flawless - a
// wrong gender in front of a learner costs trust in Clozemaster, not just in
// this page. Reports go to FeatureFeedback, anonymous ones included.
export default function ReportProblem({ reportUrl, word }) {
  const [open, setOpen] = useState(false);
  const [reason, setReason] = useState("");
  const [state, setState] = useState("idle");

  const submit = (event) => {
    event.preventDefault();
    if (state === "sending") return;

    setState("sending");

    const token = document.querySelector('meta[name="csrf-token"]');

    fetch(reportUrl, {
      body: JSON.stringify({ reason, word }),
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": token ? token.getAttribute("content") : "",
      },
      method: "POST",
    })
      .then((response) => setState(response.ok ? "sent" : "error"))
      .catch(() => setState("error"));
  };

  if (state === "sent") {
    return <div className="fna-report fna-report-sent">Thanks — we&apos;ll take a look.</div>;
  }

  if (!open) {
    return (
      <button className="fna-report-open" onClick={() => setOpen(true)} type="button">
        Report a problem
      </button>
    );
  }

  return (
    <form className="fna-report" onSubmit={submit}>
      <label htmlFor="fna-report-reason">What&apos;s wrong with &ldquo;{word}&rdquo;?</label>
      <textarea
        autoFocus
        id="fna-report-reason"
        onChange={(e) => setReason(e.target.value)}
        placeholder="Wrong gender, bad translation, not really a noun…"
        rows={2}
        value={reason}
      />
      <div className="fna-report-actions">
        <button
          className="btn btn-success btn-xs"
          disabled={!reason.trim() || state === "sending"}
          type="submit"
        >
          {state === "sending" ? "Sending…" : "Send"}
        </button>
        <button className="btn btn-link btn-xs" onClick={() => setOpen(false)} type="button">
          Cancel
        </button>
        {state === "error" && <span className="fna-report-error">Couldn&apos;t send — try again?</span>}
      </div>
    </form>
  );
}

ReportProblem.propTypes = {
  reportUrl: PropTypes.string.isRequired,
  word: PropTypes.string.isRequired,
};
